import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const submitFormData = (formData) => async (dispatch) => {
  dispatch(submitFormPending());
  try {
    const response = await axios.post('/api/submit-form', formData);
    dispatch(submitFormSuccess(response.data));
  } catch (error) {
    dispatch(submitFormError(error.message));
  }
};

const formSlice = createSlice({
  name: 'form',
  initialState: {
    status: 'idle',
    error: null,
  },
  reducers: {
    submitFormPending: (state) => {
      state.status = 'loading';
    },
    submitFormSuccess: (state) => {
      state.status = 'succeeded';
    },
    submitFormError: (state, action) => {
      state.status = 'failed';
      state.error = action.payload;
    },
  },
});

export const { submitFormPending, submitFormSuccess, submitFormError } = formSlice.actions;

export default formSlice.reducer;
